/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { Card, Col, Form, InputGroup, Row } from 'react-bootstrap'
import { Search } from 'lucide-react'
import Select from 'react-select'
import api from '../../../../config/AxiosInstance'
import * as Common from '../../../../utils/Common'

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const SelectStyles = {
  control: (base, state) => ({
    ...base,
    height: 45,
    minHeight: 45,
    borderRadius: '10px',
    borderColor: state.isFocused ? 'var(--primary-orange)' : '#e9ecef',
    boxShadow: state.isFocused ? '0 0 0 4px rgba(248, 157, 29, 0.1)' : 'none',
    backgroundColor: '#ffffff',
    border: '1px solid #e9ecef',
    fontSize: '0.9rem'
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '45px',
    padding: '0 12px'
  }),
  input: (provided) => ({
    ...provided,
    margin: '0px'
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#495057'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? 'var(--primary-orange)'
      : state.isFocused
        ? '#fff5e6'
        : null,
    color: state.isSelected ? 'white' : '#333',
    cursor: 'pointer'
  })
}

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

const FilterSection = ({
  type,
  warehouses,
  selectedWarehouse,
  setSelectedWarehouse,
  refSrcWarehouse,
  setMeta,
  source,
  setSource,
  itemCode,
  setItemCode,
  itemName,
  setItemName,
  batch,
  setBatch,
  palletId,
  setPalletId,
  stagingAreaId,
  setStagingAreaId,
  condition,
  setCondition
}) => {
  const [stagingAreaOptions, setStagingAreaOptions] = useState([])

  useEffect(() => {
    const fetchStagingAreas = async () => {
      if (!selectedWarehouse || type !== 'staging') {
        setStagingAreaOptions([])
        return
      }
      try {
        const warehouse = warehouses.find((w) => w.value === selectedWarehouse)
        const response = await api.get('/master/stagings/show', {
          params: { dest_warehouse: warehouse?.warehouse_id || '' }
        })
        const options = response.data.data.map((s) => ({
          value: s.id,
          label: s.name
        }))
        setStagingAreaOptions(options)
      } catch (err) {
        const errMsg =
          err?.response?.data?.errors?.message || 'An error occurred'
        Common.showPopUpErrorMessage(errMsg)
      }
    }
    fetchStagingAreas()
  }, [selectedWarehouse, type])

  if (type === 'vas') {
    return (
      <Card style={cardFilterStyle}>
        <Row className="g-3 mb-3">
          <Col md={4}>
            <Form.Group>
              <Form.Label style={labelStyle}>Warehouse Name</Form.Label>
              <Select
                ref={refSrcWarehouse}
                options={warehouses}
                value={warehouses.find((w) => w.value === selectedWarehouse)}
                onChange={(e) => {
                  setSelectedWarehouse(e?.value || null)
                  setMeta((prev) => ({ ...prev, current_page: 1 }))
                }}
                styles={SelectStyles}
                placeholder="Select Warehouse"
                isClearable
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label style={labelStyle}>VAS Source</Form.Label>
              <Form.Control
                type="text"
                placeholder="Input"
                value={source}
                onChange={(e) => setSource(e.target.value)}
                style={FormControlStyle}
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label style={labelStyle}>Item Code</Form.Label>
              <Form.Control
                type="text"
                placeholder="Input"
                value={itemCode}
                onChange={(e) => setItemCode(e.target.value)}
                style={FormControlStyle}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="g-3">
          <Col md={4}>
            <Form.Group>
              <Form.Label style={labelStyle}>Item Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Input"
                value={itemName}
                onChange={(e) => setItemName(e.target.value)}
                style={FormControlStyle}
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label style={labelStyle}>Batch</Form.Label>
              <Form.Control
                type="text"
                placeholder="Input"
                value={batch}
                onChange={(e) => setBatch(e.target.value)}
                style={FormControlStyle}
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label style={labelStyle}>Pallet ID</Form.Label>
              <Form.Control
                type="text"
                placeholder="Input"
                value={palletId}
                onChange={(e) => setPalletId(e.target.value)}
                style={FormControlStyle}
              />
            </Form.Group>
          </Col>
        </Row>
      </Card>
    )
  }

  if (type === 'staging') {
    return (
      <Card style={cardFilterStyle}>
        <Row className="g-3 mb-3">
          <Col md={4}>
            <Form.Group>
              <Form.Label style={labelStyle}>Warehouse Name</Form.Label>
              <Select
                ref={refSrcWarehouse}
                options={warehouses}
                value={warehouses.find((w) => w.value === selectedWarehouse)}
                onChange={(e) => {
                  setSelectedWarehouse(e?.value || null)
                  setMeta((prev) => ({ ...prev, current_page: 1 }))
                }}
                styles={SelectStyles}
                placeholder="Select Warehouse"
                isClearable
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label style={labelStyle}>Staging Area</Form.Label>
              <Select
                options={stagingAreaOptions}
                value={stagingAreaOptions.find(
                  (o) => o.value === stagingAreaId
                )}
                onChange={(e) => {
                  setStagingAreaId(e?.value || '')
                  setMeta((prev) => ({ ...prev, current_page: 1 }))
                }}
                styles={SelectStyles}
                placeholder="All"
                isClearable
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label style={labelStyle}>Item Code</Form.Label>
              <Form.Control
                type="text"
                placeholder="Input"
                value={itemCode}
                onChange={(e) => setItemCode(e.target.value)}
                style={FormControlStyle}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="g-3">
          <Col md={2}>
            <Form.Group>
              <Form.Label style={labelStyle}>Item Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Input"
                value={itemName}
                onChange={(e) => setItemName(e.target.value)}
                style={FormControlStyle}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label style={labelStyle}>Batch</Form.Label>
              <Form.Control
                type="text"
                placeholder="Input"
                value={batch}
                onChange={(e) => setBatch(e.target.value)}
                style={FormControlStyle}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label style={labelStyle}>Pallet ID</Form.Label>
              <Form.Control
                type="text"
                placeholder="Input"
                value={palletId}
                onChange={(e) => setPalletId(e.target.value)}
                style={FormControlStyle}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label style={labelStyle}>Condition</Form.Label>
              <Select
                options={[
                  { value: 'good', label: 'Good' },
                  { value: 'damaged', label: 'Damaged' }
                ]}
                value={[
                  { value: 'good', label: 'Good' },
                  { value: 'damaged', label: 'Damaged' }
                ].find((o) => o.value === condition)}
                onChange={(e) => {
                  setCondition(e?.value || '')
                  setMeta((prev) => ({ ...prev, current_page: 1 }))
                }}
                styles={SelectStyles}
                placeholder="All"
                isClearable
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label style={labelStyle}>Source Ticket</Form.Label>
              <Form.Control
                type="text"
                placeholder="All"
                value={source}
                onChange={(e) => setSource(e.target.value)}
                style={FormControlStyle}
              />
            </Form.Group>
          </Col>
        </Row>
      </Card>
    )
  }

  return (
    <Card style={cardFilterStyle}>
      <Row className="g-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label style={labelStyle}>Warehouse</Form.Label>
            <Select
              ref={refSrcWarehouse}
              options={warehouses}
              value={warehouses.find((w) => w.value === selectedWarehouse)}
              onChange={(e) => {
                setSelectedWarehouse(e?.value || null)
                setMeta((prev) => ({ ...prev, current_page: 1 }))
              }}
              styles={SelectStyles}
              placeholder="Select Warehouse"
              isClearable
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label style={labelStyle}>Search</Form.Label>
            <InputGroup>
              <InputGroup.Text
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #e9ecef',
                  borderRight: 'none',
                  borderTopLeftRadius: '10px',
                  borderBottomLeftRadius: '10px'
                }}
              >
                <Search className="text-muted" size={18} />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search Item Name or Item Code..."
                value={itemName}
                onChange={(e) => setItemName(e.target.value)}
                style={{
                  ...FormControlStyle,
                  borderLeft: 'none',
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0
                }}
              />
            </InputGroup>
          </Form.Group>
        </Col>
      </Row>
    </Card>
  )
}

export default FilterSection
